import { render, staticRenderFns } from "./CustomerTip.vue?vue&type=template&id=b088474e&scoped=true"
import script from "./CustomerTip.vue?vue&type=script&lang=js"
export * from "./CustomerTip.vue?vue&type=script&lang=js"
import style0 from "./CustomerTip.vue?vue&type=style&index=0&id=b088474e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b088474e",
  null
  
)

export default component.exports